import type {Role} from '../../../api/user';
import type {Nullable} from '../../utility-types';

import {currentUserStore} from '../../../api/user';

export const isUserHasRole = (
  role: Role,
  user: Nullable<{roles: Role[]}> = currentUserStore.user,
) => Boolean(user && user.roles.includes(role));
